/* eslint-disable @typescript-eslint/explicit-function-return-type */
import DateFnsUtils from '@date-io/date-fns';
import { Button } from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { get } from 'lodash';
import moment from 'moment';
import React, { FC, useEffect, useState } from 'react';

import useCurrentUser from '../../../hooks/useCurrentUser';
import { createTierDowngradeReport } from '../../../services/TenantReports/TierDowngradeReport.service';

interface TierDowngradeReport {
  startDate: string;
  businessId?: number;
}

const tierDowngradeInitialState: TierDowngradeReport = {
  startDate: moment()
    .subtract(1, 'month')
    .subtract(1, 'day')
    .format('YYYY-MM-DD'),
  businessId: undefined
};

interface ReportActionsProps {
  setRefreshView: (id: string) => void;
  page: number;
  offset: number;
}

const TierDowngradeReport: FC<ReportActionsProps> = ({
  setRefreshView,
  page,
  offset
}) => {
  const [filters, setFilters] = useState<TierDowngradeReport>(
    tierDowngradeInitialState
  );
  const user = useCurrentUser();

  const handleDateChange = (date: any, name: string) => {
    setFilters({ ...filters, [name]: date });
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const paramsBuId = +urlParams.get('bu')! || 0;

    setFilters(filters => ({ ...filters, businessId: paramsBuId }));
  }, [user]);

  const handleGenerateReport = (): void => {
    createTierDowngradeReport({ ...filters, page, offset }).then((res: any) => {
      const jobId = get(res, 'jobId', '');
      setRefreshView(jobId);
    });
  };
  const maxDate = moment(new Date())
    .subtract('days', 1)
    .toDate();
  return (
    <div
      style={{
        margin: '30px 0',
        display: 'flex',
        justifyContent: 'space-between'
      }}
    >
      <div>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            label="Date"
            maxDate={maxDate}
            value={filters.startDate}
            onChange={e => handleDateChange(e, 'startDate')}
            variant="inline"
            views={['year', 'month']}
            format="yyyy-MM-dd"
          />
        </MuiPickersUtilsProvider>
      </div>
      <Button
        variant="contained"
        color="primary"
        disableElevation
        onClick={handleGenerateReport}
      >
        Generate Report
      </Button>
    </div>
  );
};

export default TierDowngradeReport;
